import googleMap from './modules/map';
import stickyHeader from './modules/sticky-header';
import './modules/responsive-images';
import './modules/navigation';
import './modules/callingBack';
import './modules/cta-banner';
// import './modules/cookies';
import offerteform from './modules/offerteform';


document.addEventListener("DOMContentLoaded", () => {
    stickyHeader();
    navigation.init();
    offerteform.init();
    callingBack.init();
		ctaBanner.init();
    googleMap();
});



// WEBPACK FOOTER //
// ./resources/js/main.js